module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.exportInfo
    }
  }, [_c('i', {
    staticClass: "el-icon-download"
  }), _vm._v(" 导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.printInfo
    }
  }, [_c('i', {
    staticClass: "el-icon-printer"
  }), _vm._v(" 打印")])], 1), _vm._v(" "), _c('div', {
    staticClass: "reportInfo",
    style: ({
      height: _vm.reportInfoHeight + 'px'
    })
  }, [_c('table', {
    staticClass: "reportInfoTable",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tr', {
    staticClass: "tableTitle"
  }, [_c('td', {
    staticClass: "textCenter",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.reportInfo.semesterName) + "成绩登记表\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("开课学院：" + _vm._s(_vm.reportInfo.deptName))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("任课教师：" + _vm._s(_vm.reportInfo.teaName))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("考核方式：" + _vm._s(_vm.reportInfo.examType))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("课程名称：" + _vm._s(_vm.reportInfo.courseName))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("课程代码：" + _vm._s(_vm.reportInfo.courseCode))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("学分：" + _vm._s(_vm.reportInfo.credit))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("班级名称：" + _vm._s(_vm.reportInfo.className))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.reportInfo.scoreInfo), function(score, index) {
    return _c('tr', [_c('td', {
      staticClass: "tableBorder textCenter"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "tableBorder textCenter"
    }, [_vm._v(_vm._s(score.stuCode))]), _vm._v(" "), _c('td', {
      staticClass: "tableBorder textCenter"
    }, [_vm._v(_vm._s(score.stuName))]), _vm._v(" "), _c('td', {
      staticClass: "tableBorder textCenter"
    }, [_vm._v(_vm._s(score.usualScore))]), _vm._v(" "), _c('td', {
      staticClass: "tableBorder textCenter"
    }, [_vm._v(_vm._s(score.midScore))]), _vm._v(" "), _c('td', {
      staticClass: "tableBorder textCenter"
    }, [_vm._v(_vm._s(score.trainingScore))]), _vm._v(" "), _c('td', {
      staticClass: "tableBorder textCenter"
    }, [_vm._v(_vm._s(score.finalScore))]), _vm._v(" "), _c('td', {
      staticClass: "tableBorder textCenter"
    }, [_vm._v(_vm._s(score.totalScore))]), _vm._v(" "), _c('td', {
      staticClass: "tableBorder textCenter"
    })])
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("90分以上（优秀）")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.firstLevelNum) + " 人")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.firstLevelRatio) + " %")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("80-89分（良好）")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.secondLevelNum) + " 人")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.secondLevelRatio) + " %")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("70-79分（中等）")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.thirdLevelNum) + " 人")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.thirdLevelRatio) + " %")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("60-69分（及格）")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.fourthLevelNum) + " 人")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.fourthLevelRatio) + " %")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("不及格（不及格）")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.fifthLevelNum) + " 人")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.fifthLevelRatio) + " %")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("合计")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.examNum) + " 人")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.totalLevelRatio) + " %")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("其他")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.otherLevelNum) + " 人")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                    缓考 " + _vm._s(_vm.reportInfo.statisticsInfo.delayNum) + " 人\n                        \n                    缺考 " + _vm._s(_vm.reportInfo.statisticsInfo.absentNum) + " 人\n                        \n                    作弊 " + _vm._s(_vm.reportInfo.statisticsInfo.cheatNum) + " 人\n                        \n                    未登分 " + _vm._s(_vm.reportInfo.statisticsInfo.emptyNum) + " 人\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                    免修 / 免考 " + _vm._s(_vm.reportInfo.statisticsInfo.exemptNum) + " 人\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                    实考 " + _vm._s(_vm.reportInfo.statisticsInfo.examNum) + " 人\n                        \n                    总人数 " + _vm._s(_vm.reportInfo.statisticsInfo.totalNum) + " 人\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("\n                    平时：" + _vm._s(_vm.reportInfo.usualRatio) + " %；\n                    期中：" + _vm._s(_vm.reportInfo.midRatio) + " %；\n                    实践：" + _vm._s(_vm.reportInfo.trainingRatio) + " % ；\n                    期末：" + _vm._s(_vm.reportInfo.finalRatio) + " %\n                ")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "60px"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("学号")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("平时")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("期中")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("实践")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("期末")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("总评成绩")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("备注")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "tableBorder textCenter",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("\n                    考试/考查成绩统计\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("教研室主任：__________________")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("任课老师：__________________")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("日期：_______年____月____日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("\n                    说明：任课教师应于考试/查后三天内，将本表一式两份报至所在系部。\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57bcf1b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/scoreManage/statistics/subjectScoreReport.vue
// module id = 1836
// module chunks = 502